import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div
      className="border-b border-zinc-200 bg-white sticky top-0 z-30"
      data-testid={testid || "page-header"}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-5 flex items-end justify-between gap-6">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">
            {subtitle}
          </div>
          <h1 className="mt-1 text-2xl sm:text-3xl font-black tracking-tighter text-zinc-950">
            {title}
          </h1>
        </div>
        <div className="flex items-center gap-2 shrink-0">{actions}</div>
      </div>
    </div>
  );
}
